import {
  SAVE_TRIP_SUCCESS,
  SAVE_TRIP_REDIRECT_RESET,
  UPDATE_TRIP_SUCCESS,
  NO_EFFORT_REASON_TRIP,
  UPDATE_EFFORT_SUCCESS,
  SAVE_EFFORT_SUCCESS,
  UPDATE_CATCH_SUCCESS,
  SAVE_EFFORT_REDIRECT_RESET,
  SET_TRIP_SUCCESS,
  SET_TRIP_REDIRECT,
  LOGOUT,
  UPDATE_SALES_SUCCESS,
  NEW_SALES_SUCCESS,
  SUBMIT_TRIP_SUCCESS,
  SUBMIT_TRIP_ERROR,
  DELETE_TRIP,
  DELETE_EFFORT,
  DELETE_CATCH,
  DELETE_SALES,
  SAVE_NEW_TRIP_SUCCESS,
  RESET_CACHE,
  SAVE_OPEN_TRIP_SUCCESS,
} from "../actions/actionTypes";
import { generateEncryptedValue, replaceTrip, TripEncRow } from "../constants/vtrTrip";
import { getOpenVtrTripKey, getOpenVtrTrips } from "../actions/vtrTripStorage";
import { encryptSales, encryptTrip } from "../constants/Encrypt";
import { CatchEncRow } from "../constants/Catch";
import { getClientId } from "./rootReducer";
import { SalesEncRow } from "../constants/Sales";
import { toast } from "react-toastify";
import {
  SUBMITTED,
  SUBMIT_FAILED,
  EDITED_TRIP_RECORD,
  updateTripStatus,
} from "../constants/TripStatus";
import { setStorageValue, removeStorageValue } from "../enhancers/utils";

const initOpenTrips = getOpenVtrTrips(getClientId(), null, true);
const initOpenEncTrips = getOpenVtrTrips(getClientId(), null, false);
const initState = {
  allOpenTrips: initOpenTrips ? initOpenTrips : [],
  allEncOpenTrips: initOpenEncTrips ? initOpenEncTrips : [],
  redirect: false,
  trip_id: null,
  editRedirect: false,
  loadingTrips: true,
};

export default function tripReducer(state = initState, action) {
  let client_id;
  let trip_id;
  let openTripKey;
  let allOpenTrips;
  let allEncOpenTrips;
  let effortNr;
  let catchNr;

  if (action.hasOwnProperty("client_id")) {
    client_id = action.client_id;
    allOpenTrips = getOpenVtrTrips(client_id, null, true);
    allEncOpenTrips = getOpenVtrTrips(client_id, null, false);
    openTripKey = getOpenVtrTripKey(client_id);
  }
  if (action.hasOwnProperty("trip_id")) {
    trip_id = action.trip_id;
  }
  let currentTrip;
  if (action.hasOwnProperty("meta")) {
    currentTrip = action.meta;
  }
  let salesId;
  if (action.hasOwnProperty("sales_id")) {
    salesId = action.sales_id;
  }
  let salesRecord;
  if (action.hasOwnProperty("sales_data")) {
    salesRecord = action.sales_data;
  }
  if (action.hasOwnProperty("effort_id")) {
    effortNr = action.effort_id;
  }
  if (action.hasOwnProperty("catch_id")) {
    catchNr = action.catch_id;
  }
  switch (action.type) {
    case SET_TRIP_REDIRECT:
      state.redirect = true;
      return {
        ...state,
      };
    case SET_TRIP_SUCCESS:
      allOpenTrips = getOpenVtrTrips(client_id, null, true);
      allEncOpenTrips = getOpenVtrTrips(client_id, null, false);
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.redirect = false;
      state.editRedirect = false;
      state.loadingTrips = false;
      return {
        ...state,
      };
    case NEW_SALES_SUCCESS:
      console.group("NEW_SALES_SUCCESS");
      console.log("action", action);
      console.log("allOpentrips", allOpenTrips);
      console.log("new sales records in ", salesRecord);
      if (allOpenTrips) {
        for (let e = 0; e < allOpenTrips.length; e++) {
          console.log("trip", trip_id);
          if (allOpenTrips[e].trip_id === trip_id) {
            console.log("same trip found");
            let salesData = allOpenTrips[e].sales;
            let salesNr = salesData.length;
            if (salesData) {
              let newSales = salesRecord.selectedSales;
              //TODO add the new sales records
              for (let a = 0; a < newSales.length; a++) {
                let s = new SalesEncRow();
                s.setDateSold(salesRecord.date_sold);
                s.setDealerName(salesRecord.dealer_name);
                s.setDealerPermitNumber(salesRecord.dealer_permit_number);
                s.setSold(newSales[a].sold);
                s.setOffLoadingPort(salesRecord.offloading_port);
                s.setSpecies(newSales[a].species);
                s.setUom(newSales[a].sales_uom);
                // TODO: review below condition. Is it report_type available here?
                if (["CLHB", "CLQUB", "CLSOB", "CLSUB"].includes(newSales[a].species)) {
                  s.setPricePerBushel(salesRecord.price_per_bushel);
                  s.setAllocationNumbers(salesRecord.allocation_numbers);
                  s.setTagNumbers(salesRecord.tag_numbers);
                }
                allOpenTrips[e].sales[salesNr] = s;
                allEncOpenTrips[e].sales[salesNr] = encryptSales(s, client_id);
                salesNr++;
                console.log("new sales ", s);
              }
            }
          }
        }
      }
      setStorageValue(openTripKey, allEncOpenTrips);
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.redirect = true;
      console.log("set redirect");
      console.groupEnd();
      return {
        ...state,
      };
    case UPDATE_SALES_SUCCESS:
      if (allOpenTrips) {
        for (let e = 0; e < allOpenTrips.length; e++) {
          if (allOpenTrips[e].trip_id === trip_id) {
            allOpenTrips[e].trip_status = updateTripStatus(allOpenTrips[e].trip_status);
            let salesData = allOpenTrips[e].sales;
            console.log("current_all_sales?", salesData, salesId);
            if (salesData) {
              console.log("current_sales?", salesData[salesId]);
              if (salesData[salesId]) {
                let currentSales = salesData[salesId];
                if (salesRecord.hasOwnProperty("species")) {
                  currentSales.species = salesRecord.species;
                }
                if (salesRecord.hasOwnProperty("dealer_permit_number")) {
                  currentSales.dealer_permit_number = salesRecord.dealer_permit_number;
                }
                if (salesRecord.hasOwnProperty("dealer_name")) {
                  currentSales.dealer_name = salesRecord.dealer_name;
                }
                if (salesRecord.hasOwnProperty("sold")) {
                  currentSales.sold = salesRecord.sold;
                }
                if (salesRecord.hasOwnProperty("date_sold")) {
                  currentSales.date_sold = salesRecord.date_sold;
                }
                if (salesRecord.hasOwnProperty("offloading_port")) {
                  currentSales.offloading_port = salesRecord.offloading_port;
                }
                if (salesRecord.hasOwnProperty("uom")) {
                  currentSales.uom = salesRecord.uom;
                }
                // * review this code.  To change with report_type condition.
                if (["CLHB", "CLQUB", "CLSOB", "CLSUB"].includes(salesRecord.species)) {
                  if (salesRecord.hasOwnProperty("price_per_bushel")) {
                    currentSales.price_per_bushel = salesRecord.price_per_bushel;
                  }
                  if (salesRecord.hasOwnProperty("allocation_numbers")) {
                    currentSales.allocation_numbers = salesRecord.allocation_numbers;
                  }
                  if (salesRecord.hasOwnProperty("tag_numbers")) {
                    currentSales.tag_numbers = salesRecord.tag_numbers;
                  }
                }

                allOpenTrips[e].sales[salesId] = currentSales;
                allEncOpenTrips[e] = encryptTrip(allOpenTrips[e], client_id);
                console.log("update Sales", currentSales);
              } else {
                let s = new SalesEncRow();
                s.setDateSold(salesRecord.date_sold);
                s.setDealerName(salesRecord.dealer_name);
                s.setDealerPermitNumber(salesRecord.dealer_permit_number);
                s.setSold(salesRecord.sold);
                s.setOffLoadingPort(salesRecord.offloading_port);
                s.setSpecies(salesRecord.species);
                s.setUom(salesRecord.uom);
                // * review this code.  To change with report_type condition.
                if (["CLHB", "CLQUB", "CLSOB", "CLSUB"].includes(salesRecord.species)) {
                  s.setPricePerBushel(salesRecord.price_per_bushel);
                  s.setAllocationNumbers(salesRecord.allocation_numbers);
                  s.setTagNumbers(salesRecord.tag_numbers);
                }

                allOpenTrips[e].sales[salesId] = s;
                allEncOpenTrips[e] = encryptTrip(allOpenTrips[e], client_id);
                console.log("new sales ", s);
              }

              setStorageValue(openTripKey, allEncOpenTrips);
              state.allOpenTrips = allOpenTrips;
              state.allEncOpenTrips = allEncOpenTrips;
              state.redirect = true;
              console.log("set redirect");
            }
            break;
          }
        }
      }
      state.allEncOpenTrips = allEncOpenTrips;
      state.allOpenTrips = allOpenTrips;
      console.log("new state", state);
      return {
        ...state,
      };
    case UPDATE_EFFORT_SUCCESS:
      if (!currentTrip || String.isPrototypeOf(currentTrip)) {
        return "No trip or invalid type provided";
      }
      let currentOpenTrip;
      if (allOpenTrips) {
        let updateEffortNr = currentTrip.effortNr;
        for (let e = 0; e < allOpenTrips.length; e++) {
          if (allOpenTrips[e].trip_id === currentTrip.trip_id) {
            currentOpenTrip = allOpenTrips[e];
            currentOpenTrip.trip_status = updateTripStatus(currentOpenTrip.trip_status);
            if (
              currentOpenTrip.hasOwnProperty("images") &&
              Array.isArray(currentOpenTrip.images)
            ) {
              if (currentOpenTrip.images[updateEffortNr]) {
                // update the open trip fields that have changed
                let currentEffort = currentOpenTrip.images[updateEffortNr];
                if (currentTrip.hasOwnProperty("gearcode")) {
                  currentEffort.gearcode = currentTrip.gearcode;
                }
                if (currentTrip.hasOwnProperty("gearname")) {
                  currentEffort.gearname = currentTrip.gearname;
                }
                if (currentTrip.hasOwnProperty("gearqty")) {
                  currentEffort.gearqty = currentTrip.gearqty;
                }
                if (currentTrip.hasOwnProperty("gearsize")) {
                  currentEffort.gearsize = currentTrip.gearsize;
                }
                if (currentTrip.hasOwnProperty("mesh_size")) {
                  currentEffort.mesh_size = currentTrip.mesh_size;
                }
                if (currentTrip.hasOwnProperty("chart_area")) {
                  currentEffort.chart_area = currentTrip.chart_area;
                }
                if (currentTrip.hasOwnProperty("fishing_depth")) {
                  currentEffort.fishing_depth = currentTrip.fishing_depth;
                }
                if (currentTrip.hasOwnProperty("fishing_depth_uom")) {
                  currentEffort.fishing_depth_uom = currentTrip.fishing_depth_uom;
                }
                if (currentTrip.hasOwnProperty("number_of_hauls")) {
                  currentEffort.number_of_hauls = currentTrip.number_of_hauls;
                }
                if (currentTrip.hasOwnProperty("tow_soak_time")) {
                  currentEffort.tow_soak_time = currentTrip.tow_soak_time;
                }
                if (currentTrip.hasOwnProperty("lat_long_format")) {
                  currentEffort.lat_long_format = currentTrip.lat_long_format;
                }
                if (currentTrip.hasOwnProperty("latitude_or_loran1")) {
                  currentEffort.latitude_or_loran1 = currentTrip.latitude_or_loran1;
                }
                if (currentTrip.hasOwnProperty("longitude_or_loran2")) {
                  currentEffort.longitude_or_loran2 = currentTrip.longitude_or_loran2;
                }
                if (
                  currentTrip.hasOwnProperty("numTrapsHauled") &&
                  currentTrip.hasOwnProperty("numTrapsInWater") &&
                  currentTrip.hasOwnProperty("numTrapsPerString") &&
                  currentTrip.hasOwnProperty("numBuoyLines") &&
                  currentTrip.hasOwnProperty("stringsHauled") &&
                  currentTrip.hasOwnProperty("avgSoakTime")
                ) {
                  currentEffort.numTrapsHauled = currentTrip.numTrapsHauled;
                  currentEffort.numTrapsInWater = currentTrip.numTrapsInWater;
                  currentEffort.numTrapsPerString = currentTrip.numTrapsPerString;
                  currentEffort.numBuoyLines = currentTrip.numBuoyLines;
                  currentEffort.stringsHauled = currentTrip.stringsHauled;
                  currentEffort.avgSoakTime = currentTrip.avgSoakTime;
                }
                allOpenTrips[e].images[updateEffortNr] = currentEffort;
                allEncOpenTrips[e] = encryptTrip(allOpenTrips[e], client_id);
                console.log("new effort ", currentEffort);
                break;
              }
            }
          }
        }
        console.log("new trips object", allOpenTrips);
        setStorageValue(openTripKey, allEncOpenTrips);
        state.allOpenTrips = allOpenTrips;
        state.allEncOpenTrips = allEncOpenTrips;
        state.redirect = true;
      }
      return {
        ...state,
      };
    case SAVE_EFFORT_SUCCESS:
      if (!currentTrip || String.isPrototypeOf(currentTrip)) {
        return "No trip or invalid type provided";
      }
      //create the combined tripsObject
      if (allOpenTrips) {
        for (let e = 0; e < allOpenTrips.length; e++) {
          if (allOpenTrips[e].trip_id === currentTrip.trip_id) {
            allOpenTrips[e] = currentTrip;
            allEncOpenTrips[e] = encryptTrip(allOpenTrips[e], client_id);
            break;
          }
        }
        setStorageValue(openTripKey, allEncOpenTrips);
      } else {
        console.error("SAVE_EFFORT_SUCCESS", "No old trips found");
      }
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.redirect = true;
      return { ...state };
    case UPDATE_CATCH_SUCCESS:
      if (!currentTrip || String.isPrototypeOf(currentTrip)) {
        return "No trip or invalid type provided";
      }

      if (allOpenTrips) {
        let c = new CatchEncRow();
        c.setKept(currentTrip.kept);
        c.setDiscarded(currentTrip.discarded);
        c.setSpecies(currentTrip.species);
        c.setUom(currentTrip.uom);
        const nrOpenTrips = allOpenTrips.length;
        for (let e = 0; e < nrOpenTrips; e++) {
          if (allOpenTrips[e].trip_id === currentTrip.trip_id) {
            let currentEffort = allOpenTrips[e].images[effortNr];
            if (currentEffort.catch) {
              if (currentTrip.isExisting && currentEffort.catch[catchNr]) {
                allOpenTrips[e].images[effortNr].catch[catchNr] = c;
              } else {
                if (
                  currentEffort.catch[catchNr] &&
                  currentEffort.catch[catchNr].hasOwnProperty("species")
                ) {
                  let currentNrCatches = currentEffort.catch.length;
                  allOpenTrips[e].images[effortNr].catch[currentNrCatches] = c;
                } else {
                  allOpenTrips[e].images[effortNr].catch[catchNr] = c;
                }
              }
            }
            allEncOpenTrips[e] = encryptTrip(allOpenTrips[e], client_id);
            break;
          }
        }
        setStorageValue(openTripKey, allEncOpenTrips);
      } else {
        console.error("update_catch", "No old trips found");
      }
      console.log("update_catch_save", allOpenTrips);
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.redirect = true;
      return { ...state };
    case SAVE_EFFORT_REDIRECT_RESET:
      return { ...state, redirect: false };
    case SAVE_OPEN_TRIP_SUCCESS:
      console.log(currentTrip);
      const tripStart = currentTrip.VTR_DOCID;
      const tripHeader = tripStart.document;
      const tripEffort = tripStart.subtrips;
      const tripSales = tripStart.sales;
      trip_id = tripHeader.trip_id;
      allOpenTrips = getOpenVtrTrips(client_id, null, true);
      allEncOpenTrips = getOpenVtrTrips(client_id, null, false);
      openTripKey = getOpenVtrTripKey(client_id);
      const updateTrip = replaceTrip(tripHeader, tripEffort, tripSales);
      const updateTripEncObject = encryptTrip(updateTrip, client_id);

      let existingFound = false;
      if (Array.isArray(allOpenTrips)) {
        const nrOpenTrips = allOpenTrips.length;
        for (let e = 0; e < nrOpenTrips; e++) {
          if (allOpenTrips[e].trip_id === trip_id) {
            allOpenTrips[e] = updateTrip;
            allEncOpenTrips[e] = updateTripEncObject;
            existingFound = true;
            setStorageValue(openTripKey, allEncOpenTrips);
          }
        }
      }
      if (!existingFound) {
        allOpenTrips[allOpenTrips.length] = updateTrip;
        allEncOpenTrips[allEncOpenTrips.length] = updateTripEncObject;
        setStorageValue(openTripKey, allEncOpenTrips);
      }

      state.redirect = true;
      state.editRedirect = true;
      state.trip_id = updateTrip.trip_id;
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.loadingTrips = false;
      return { ...state };
    case SAVE_NEW_TRIP_SUCCESS:
      let newOpenTrip = action.meta;
      if (!newOpenTrip || String.isPrototypeOf(newOpenTrip)) {
        return "No trip or invalid type provided";
      }
      let doc = newOpenTrip.VTR_DOCID;
      let trip = doc.document;
      trip.trip_status = EDITED_TRIP_RECORD;
      let newTripObject = replaceTrip(trip, doc.subtrips, doc.sales);
      let newTripEncObject = encryptTrip(newTripObject, client_id);

      if (allOpenTrips) {
        //append trip to the current Array
        allOpenTrips[allOpenTrips.length] = newTripObject;
        allEncOpenTrips[allEncOpenTrips.length] = newTripEncObject;
        setStorageValue(openTripKey, allEncOpenTrips);
      } else {
        let tripArray = [];
        let tripEncArray = [];
        //put the object in array
        tripArray[0] = newTripObject;
        tripEncArray[0] = newTripEncObject;
        //save the new array
        setStorageValue(openTripKey, tripEncArray);
        allOpenTrips = tripArray;
        allEncOpenTrips = tripEncArray;
      }
      state.redirect = true;
      state.editRedirect = true;
      state.trip_id = newTripObject.trip_id;
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.loadingTrips = false;
      return { ...state };
    case SAVE_TRIP_SUCCESS:
      let newTrip = action.meta;
      if (!newTrip || String.isPrototypeOf(newTrip)) {
        return "No trip or invalid type provided";
      }
      //create the tripObject
      let tripObject = new TripEncRow();
      tripObject.setTripId(newTrip.trip_id);
      tripObject.setDateSail(newTrip.date_sail);
      tripObject.setNumberOfAnglers(newTrip.number_of_anglers);
      tripObject.setNumberOfCrew(newTrip.number_of_crew);
      tripObject.setOperatorFirstName(newTrip.operator_first_name);
      tripObject.setOperatorLastName(newTrip.operator_last_name);
      tripObject.setOperatorMiddleName(newTrip.operator_middle_name);
      tripObject.setOperatorExtName(newTrip.operator_ext_name);
      tripObject.setOperatorPermitNumber(newTrip.operator_permit_number);
      tripObject.setReportType(newTrip.report_type);
      tripObject.setTripType(newTrip.trip_type);
      tripObject.setVesselName(newTrip.vessel_name);
      tripObject.setVesselPermitNum(newTrip.vessel_permit_num);
      tripObject.setVesselRegistration(newTrip.vessel_registration);
      tripObject.setNoEffortTripReason(newTrip.no_effort_trip_reason);
      tripObject.setTripStatus(newTrip.trip_status);
      tripObject.setBuoyLines(newTrip.buoyLines);
      tripObject.setTrapsPerString(newTrip.trapsPerString);
      tripObject.setTrapsInWater(newTrip.trapsInWater);
      tripObject.setDefaultUOM(newTrip.default_uom);
      tripObject.setDefaultSpeciesUOM(newTrip.default_species_uom);

      let tripEncObject = encryptTrip(tripObject, client_id);
      if (allOpenTrips) {
        //append trip to the current Array
        allOpenTrips[allOpenTrips.length] = tripObject;
        allEncOpenTrips[allEncOpenTrips.length] = tripEncObject;
        setStorageValue(openTripKey, allEncOpenTrips);
      } else {
        let tripArray = [];
        let tripEncArray = [];
        //put the object in array
        tripArray[0] = tripObject;
        tripEncArray[0] = tripEncObject;
        //save the new array
        setStorageValue(openTripKey, tripEncArray);
        allOpenTrips = tripArray;
        allEncOpenTrips = tripEncArray;
      }
      state.redirect = true;
      state.editRedirect = false;
      state.trip_id = tripObject.trip_id;
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.loadingTrips = false;
      return { ...state };
    case UPDATE_TRIP_SUCCESS:
      let currentTripChanges = action.meta;
      for (let e = 0; e < allOpenTrips.length; e++) {
        if (allOpenTrips[e].trip_id === trip_id) {
          if (currentTripChanges.hasOwnProperty("report_type")) {
            allOpenTrips[e].report_type = currentTripChanges.report_type;
          }
          if (currentTripChanges.hasOwnProperty("trip_type")) {
            allOpenTrips[e].trip_type = currentTripChanges.trip_type;
          }
          if (currentTripChanges.hasOwnProperty("number_of_anglers")) {
            allOpenTrips[e].number_of_anglers = currentTripChanges.number_of_anglers;
          }
          if (currentTripChanges.hasOwnProperty("number_of_crew")) {
            allOpenTrips[e].number_of_crew = currentTripChanges.number_of_crew;
          }
          if (currentTripChanges.hasOwnProperty("vessel_name")) {
            allOpenTrips[e].vessel_name = currentTripChanges.vessel_name;
          }
          if (currentTripChanges.hasOwnProperty("vessel_permit_num")) {
            allOpenTrips[e].vessel_permit_num = currentTripChanges.vessel_permit_num;
          }
          if (currentTripChanges.hasOwnProperty("vessel_registration")) {
            allOpenTrips[e].vessel_registration = currentTripChanges.vessel_registration;
          }
          if (currentTripChanges.hasOwnProperty("operator_first_name")) {
            allOpenTrips[e].operator_first_name = currentTripChanges.operator_first_name;
          }
          if (currentTripChanges.hasOwnProperty("operator_middle_name")) {
            allOpenTrips[e].operator_middle_name =
              currentTripChanges.operator_middle_name;
          }
          if (currentTripChanges.hasOwnProperty("operator_last_name")) {
            allOpenTrips[e].operator_last_name = currentTripChanges.operator_last_name;
          }
          if (currentTripChanges.hasOwnProperty("operator_ext_name")) {
            allOpenTrips[e].operator_ext_name = currentTripChanges.operator_ext_name;
          }
          if (currentTripChanges.hasOwnProperty("operator_permit_number")) {
            allOpenTrips[e].operator_permit_number =
              currentTripChanges.operator_permit_number;
          }
          if (currentTripChanges.hasOwnProperty("date_sail")) {
            allOpenTrips[e].date_sail = currentTripChanges.date_sail;
          }
          if (currentTripChanges.hasOwnProperty("date_land")) {
            allOpenTrips[e].date_land = currentTripChanges.date_land;
          }
          if (currentTripChanges.hasOwnProperty("no_effort_trip_reason")) {
            allOpenTrips[e].no_effort_trip_reason =
              currentTripChanges.no_effort_trip_reason;
          }
          if (currentTripChanges.hasOwnProperty("buoyLines")) {
            allOpenTrips[e].buoyLines = currentTripChanges.buoyLines;
          }
          if (currentTripChanges.hasOwnProperty("trapsPerString")) {
            allOpenTrips[e].trapsPerString = currentTripChanges.trapsPerString;
          }
          if (currentTripChanges.hasOwnProperty("trapsInWater")) {
            allOpenTrips[e].trapsInWater = currentTripChanges.trapsInWater;
          }
          if (currentTripChanges.hasOwnProperty("default_uom")) {
            allOpenTrips[e].default_uom = currentTripChanges.default_uom;
          }
          if (currentTripChanges.hasOwnProperty("default_species_uom")) {
            allOpenTrips[e].default_species_uom = currentTripChanges.default_species_uom;
          }
          allOpenTrips[e].trip_status = updateTripStatus(allOpenTrips[e].trip_status);
          allEncOpenTrips[e] = encryptTrip(allOpenTrips[e], client_id);
        }
      }
      setStorageValue(openTripKey, allEncOpenTrips);
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.redirect = true;
      state.editRedirect = false;
      state.loadingTrips = false;
      return { ...state };
    case SAVE_TRIP_REDIRECT_RESET:
      console.log("SAVE_TRIP_REDIRECT_RESET", state);
      return { ...state, redirect: false, editRedirect: false };
    case NO_EFFORT_REASON_TRIP:
      let noEffortTripChanges = action.meta;
      for (let e = 0; e < allOpenTrips.length; e++) {
        if (allOpenTrips[e].trip_id === trip_id) {
          if (noEffortTripChanges.hasOwnProperty("no_effort_trip_reason")) {
            allOpenTrips[e].no_effort_trip_reason =
              noEffortTripChanges.no_effort_trip_reason;
            // * Clearing the lobster fields in case populated
            if (
              noEffortTripChanges.no_effort_trip_reason !== "0" &&
              allOpenTrips[e].report_type === "2"
            ) {
              allOpenTrips[e].trapsInWater = null;
              allOpenTrips[e].trapsPerString = null;
              allOpenTrips[e].buoyLines = null;
              //
              allEncOpenTrips[e].trapsInWater = null;
              allEncOpenTrips[e].trapsPerString = null;
              allEncOpenTrips[e].buoyLines = null;
            }
            allEncOpenTrips[e].no_effort_trip_reason = generateEncryptedValue(
              noEffortTripChanges.no_effort_trip_reason,
              client_id
            );
            console.info(allEncOpenTrips[e]);
          }
          if (allOpenTrips[e].hasOwnProperty("images")) {
            delete allOpenTrips[e].images;
            delete allEncOpenTrips[e].images;
          }
          break;
        }
      }
      setStorageValue(openTripKey, allEncOpenTrips);
      state.allOpenTrips = allOpenTrips;
      state.allEncOpenTrips = allEncOpenTrips;
      state.redirect = true;
      return { ...state };
    case SUBMIT_TRIP_SUCCESS:
      if (allOpenTrips) {
        for (let e = 0; e < allOpenTrips.length; e++) {
          if (allOpenTrips[e].trip_id === trip_id) {
            allOpenTrips[e].submitted_success = true;
            allOpenTrips[e].submitted_trip = true;
            allOpenTrips[e].trip_status = SUBMITTED;
            allEncOpenTrips[e].submitted_success = true;
            allEncOpenTrips[e].submitted_trip = true;
            allEncOpenTrips[e].trip_status = generateEncryptedValue(SUBMITTED, client_id);
          }
        }
        state.allOpenTrips = allOpenTrips;
        state.allEncOpenTrips = allEncOpenTrips;
        setStorageValue(openTripKey, allEncOpenTrips);
      }
      state.redirect = true;
      state.editRedirect = false;
      state.loadingTrips = false;
      toast.success(`Submission Status: ${action.data.status}`);
      return { ...state };
    case DELETE_CATCH:
      if (allOpenTrips) {
        let deletedCatch = [];
        let deletedEncCatch = [];
        let nrOpenTrips = allOpenTrips.length;
        for (let e = 0; e < nrOpenTrips; e++) {
          if (allOpenTrips[e].trip_id === trip_id) {
            if (allOpenTrips[e].images[effortNr]) {
              if (allOpenTrips[e].images[effortNr].catch[catchNr]) {
                deletedCatch = allOpenTrips[e].images[effortNr].catch.splice(catchNr, 1);
                deletedEncCatch = allEncOpenTrips[e].images[effortNr].catch.splice(
                  catchNr,
                  1
                );
              }
            }
            break;
          }
        }
        console.log("deleted_enc_catch", deletedEncCatch);
        if (deletedCatch.length > 0) {
          state.allOpenTrips = allOpenTrips;
          state.allEncOpenTrips = allEncOpenTrips;
          setStorageValue(openTripKey, allEncOpenTrips);
          state.redirect = true;
        }
      }
      return { ...state };
    case DELETE_SALES:
      if (allOpenTrips) {
        let deletedSales = [];
        let deletedEncSales = [];
        let nrOpenTrips = allOpenTrips.length;
        for (let e = 0; e < nrOpenTrips; e++) {
          if (allOpenTrips[e].trip_id === trip_id) {
            if (allOpenTrips[e].sales[salesId]) {
              deletedSales = allOpenTrips[e].sales.splice(salesId, 1);
              deletedEncSales = allEncOpenTrips[e].sales.splice(salesId, 1);
            }
            break;
          }
        }
        console.log("deleted_enc_sales", deletedEncSales);
        if (deletedSales.length > 0) {
          console.log("update state");
          state.allOpenTrips = allOpenTrips;
          state.allEncOpenTrips = allEncOpenTrips;
          setStorageValue(openTripKey, allEncOpenTrips);
          state.redirect = true;
        }
      }
      return { ...state };
    case DELETE_EFFORT:
      if (allOpenTrips) {
        let deletedEffort = [];
        let deletedEncEffort = [];
        let nrOpenTrips = allOpenTrips.length;
        for (let e = 0; e < nrOpenTrips; e++) {
          if (allOpenTrips[e].trip_id === trip_id) {
            if (allOpenTrips[e].images[effortNr]) {
              deletedEffort = allOpenTrips[e].images.splice(effortNr, 1);
              deletedEncEffort = allEncOpenTrips[e].images.splice(effortNr, 1);
            }
            break;
          }
        }
        console.log("deleted_enc_effort", deletedEncEffort);
        if (deletedEffort.length > 0) {
          console.log("update state");
          state.allOpenTrips = allOpenTrips;
          state.allEncOpenTrips = allEncOpenTrips;
          setStorageValue(openTripKey, allEncOpenTrips);
          state.redirect = true;
        }
      }
      return { ...state };
    case DELETE_TRIP:
      if (allOpenTrips) {
        let newOpenTrips = [];
        let newEncOpenTrips = [];
        let deletedTrip = [];
        let deletedEncTrip = [];
        let nrOpenTrips = allOpenTrips.length;
        for (let e = 0; e < nrOpenTrips; e++) {
          if (allOpenTrips[e].trip_id === trip_id) {
            deletedTrip = allOpenTrips.splice(e, 1);
            deletedEncTrip = allEncOpenTrips.splice(e, 1);
            newOpenTrips = allOpenTrips;
            newEncOpenTrips = allEncOpenTrips;
            break;
          }
        }
        console.log("deleted_enc_trip", deletedEncTrip);
        if (deletedTrip.length > 0) {
          console.log("update state");
          state.allOpenTrips = newOpenTrips;
          state.allEncOpenTrips = newEncOpenTrips;
          setStorageValue(openTripKey, newEncOpenTrips);
        }
      }
      return { ...state };
    case SUBMIT_TRIP_ERROR:
      if (allOpenTrips) {
        for (let e = 0; e < allOpenTrips.length; e++) {
          if (allOpenTrips[e].trip_id === trip_id) {
            allOpenTrips[e].submitted_success = false;
            allOpenTrips[e].submitted_trip = true;
            allOpenTrips[e].trip_status = SUBMIT_FAILED;
            allEncOpenTrips[e].submitted_success = false;
            allEncOpenTrips[e].submitted_trip = false;
            allEncOpenTrips[e].trip_status = generateEncryptedValue(
              SUBMIT_FAILED,
              client_id
            );
          }
        }
        state.allOpenTrips = allOpenTrips;
        state.allEncOpenTrips = allEncOpenTrips;
        setStorageValue(openTripKey, allEncOpenTrips);
      }
      state.redirect = false;
      state.editRedirect = false;
      return { ...state };
    case RESET_CACHE:
      if (openTripKey) {
        removeStorageValue(openTripKey);
      }
      state.allOpenTrips = [];
      state.allEncOpenTrips = [];
      state.redirect = false;
      state.editRedirect = false;
      state.trip_id = null;
      state.loadingTrips = false;

      return { ...state };
    case LOGOUT:
      state.allOpenTrips = [];
      state.allEncOpenTrips = [];
      state.redirect = false;
      state.editRedirect = false;
      state.loadingTrips = false;
      state.trip_id = null;
      return { ...state };
    default:
      state.loadingTrips = false;
      return state;
  }
}
